export default __webpack_public_path__ + "66ee271.png";